const GET_INFO_ME_2 = 'GET_INFO_ME_2'
const GET_INFO_ME_2_SUCCESS = 'GET_INFO_ME_2_SUCCESS'


const InfoMeType = {
  GET_INFO_ME_2,
  GET_INFO_ME_2_SUCCESS

}

export default InfoMeType
